<script setup lang="ts">
import { UiButton, UiModal } from "@packages/component-library";
import { usePlaceStore } from "@/modules/place-module";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["close"]);
const { t } = useI18n();
const placeStore = usePlaceStore();
const pointPercent = computed(() => placeStore.place?.place.points_percent);
const showModal = ref(false);

onMounted(() => {
  showModal.value = true;
});
</script>

<template>
  <UiModal
    v-model="showModal"
    size="s"
    :title="t('place.paymentModal.title', { percent: pointPercent })"
    @update:modelValue="emit('close')"
  >
    <template #default>
      <div class="payment-info">
        <p>
          {{ t("place.paymentModal.description", { percent: pointPercent }) }}
        </p>
      </div>
    </template>

    <template #footer>
      <div class="payment-info__actions">
        <UiButton
          :label="t('system.clearly')"
          size="m"
          data-test-id="placePayment-button-close"
          @click="emit('close')"
        />
      </div>
    </template>
  </UiModal>
</template>

<style scoped lang="scss">
.payment-info {
  > p {
    @include body-m();
    color: var(--color-semantic-content-normal-primary);
  }

  &__actions {
    width: 100%;
    > button {
      width: 100%;
    }
  }
}
</style>
